import { useMutation, useQuery } from "@tanstack/react-query";

import { Data, DataMany, Responsible } from "@/shared/types.ts";
import {
  AccumulatorDetail,
  AccumulatorEntity,
} from "@/features/accumulators/types.ts";
import api from "@/shared/api";
import { OrdersEntity } from "@/features/order/types.ts";
import dom from "@/shared/helper/dom.helper.ts";

export function useAccumulators({ enabled = true }: { enabled?: boolean }) {
  return useQuery<DataMany<AccumulatorEntity[]>>({
    queryKey: ["accumulators"],
    queryFn: () =>
      api
        .get<
          DataMany<AccumulatorEntity[]>
        >(`https://gateway.maguya.kz/orders/accumulator/get/all`)
        .json(),
    enabled,
    initialData: {
      data: [],
      total: 0,
      code: 0,
      success: true,
      description: "Успех",
    } as DataMany<AccumulatorEntity[]>,
  });
}

export function useAccumulatorById({
  accumulatorId,
  enabled = true,
}: {
  accumulatorId: string | number;
  enabled?: boolean;
}) {
  return useQuery<Data<AccumulatorDetail>>({
    queryKey: ["accumulator", String(accumulatorId)],
    queryFn: () =>
      api
        .get<
          Data<AccumulatorDetail>
        >(`/api/v1/accumulator/get/by/id/${accumulatorId}`)
        .json(),
    enabled: enabled && Boolean(accumulatorId),
  });
}

export function useExportAccumulator() {
  return useMutation<Responsible<string>, void, { accumulatorId: number }>({
    mutationFn: ({ accumulatorId }) =>
      api
        .post<Data<OrdersEntity>>(`/api/v1/orders/accumulator/manifest`, {
          headers: { "content-type": "application/json;" },
          body: JSON.stringify({ accumulatorId }),
          timeout: 60 * 1000,
        })
        .json(),
    onSuccess: ({ data }) => dom.openFileFromBase64(data),
  });
}
